module.exports = __webpack_public_path__ + "img/changename2.28ba89e6.jpg";